// removed by extract-text-webpack-plugin
module.exports = {"container":"container__container___2d73f"};


//////////////////
// WEBPACK FOOTER
// ./src/js/Components/Container/container.scss
// module id = 121
// module chunks = 0